var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg130(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0081 5.61426C36.7542 3.55948 35.0036 1.96853 32.8802 1.96853H28.4464V1.4187C28.4465 0.635136 27.8113 0 27.0277 0H20.9712C20.1877 0 19.5525 0.635136 19.5525 1.4187V1.96853H15.1189C12.9955 1.96853 11.2448 3.55948 10.9909 5.61426C7.09997 6.36169 4.15039 9.78975 4.15039 13.8956V36.5402C4.15039 38.5672 4.88033 40.5269 6.20564 42.0579C7.35904 43.3905 8.89719 44.3248 10.5929 44.7366V46.24C10.5929 47.212 11.3809 48 12.353 48H35.8414C36.8134 48 37.6014 47.212 37.6014 46.24V44.6895L37.766 44.6417C41.3476 43.6037 43.849 40.2723 43.849 36.5401V13.8954C43.8488 9.78975 40.8992 6.36169 37.0081 5.61426ZM14.1127 44.4799V19.6133H27.3123V26.2498H34.0811V44.4798H14.1127V44.4799ZM40.3287 36.5402C40.3287 38.4187 39.2414 40.1222 37.6012 40.9413V24.9325C37.6012 24.459 37.4104 24.0055 37.072 23.6744L29.8364 16.5952C29.5075 16.2735 29.0657 16.0932 28.6055 16.0932H12.3527C11.3807 16.0932 10.5927 16.8813 10.5927 17.8533V41.0312C8.86352 40.2563 7.67033 38.5041 7.67033 36.5402V13.8954C7.67033 11.7557 9.0455 9.93208 10.958 9.25905V10.1741H37.0411V9.25905C38.9537 9.93196 40.3287 11.7557 40.3287 13.8954V36.5402Z",
    fill: "#E8202D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.216 29.2788H16.9785V31.6255H31.216V29.2788Z",
    fill: "#E8202D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.216 32.7314H16.9785V35.0781H31.216V32.7314Z",
    fill: "#E8202D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.216 36.1841H16.9785V38.5308H31.216V36.1841Z",
    fill: "#E8202D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.216 39.6367H16.9785V41.9834H31.216V39.6367Z",
    fill: "#E8202D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg130);
export default __webpack_public_path__ + "static/media/svg130.ca4839bc158369d48563c1f9adfd8495.svg";
export { ForwardRef as ReactComponent };